import { render, staticRenderFns } from "./academic_course_management.vue?vue&type=template&id=89e5d718&scoped=true&"
import script from "./academic_course_management.vue?vue&type=script&lang=js&"
export * from "./academic_course_management.vue?vue&type=script&lang=js&"
import style0 from "./academic_course_management.vue?vue&type=style&index=0&id=89e5d718&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e5d718",
  null
  
)

export default component.exports